import { FlightState, TypeFlight } from "@/lib/redux/features/flight/type"

export const byPrice = (state: FlightState, flight: TypeFlight) => {
  const firstSegment = flight.segments[0]
  const lastSegment = flight.segments[flight.segments.length - 1]
  const route = `${firstSegment.startPoint}${lastSegment.endPoint}`
  const minPrice = state.flightsResult.filters.minPrice[route]
  const maxPrice = state.flightsResult.filters.maxPrice[route]

  if (minPrice == null || maxPrice == null) {
    return true
  }

  const matchesPrice = (price: number) => price >= minPrice && price <= maxPrice

  // Bounds are built from fareAdt in callbackSearchFlights; compare in the same unit.
  return flight.inventories.some((inventory) => matchesPrice(Number(inventory.fareAdt)))
}